/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { Center, useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import { type GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Cylinder003_1: Mesh
      Cylinder003_2: Mesh
    }
    materials: {
      Grey: MeshStandardMaterial
      Back: MeshStandardMaterial
    }
  }

export function Camera(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/camera.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <Center>
        <group
          position={[0, 2.005, -1.028]}
          rotation={[Math.PI / 2, -Math.PI / 2, 0]}
          scale={[100, 100, 18.464]}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cylinder003_1.geometry}
            material={materials.Grey}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cylinder003_2.geometry}
            material={materials.Back}
          />
        </group>
      </Center>
    </group>
  )
}

useGLTF.preload('/models/camera.glb')
